import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";

// we can render a progress bar or something eventually

export var PercentDisplay = function (_PureComponent) {
  _inherits(PercentDisplay, _PureComponent);

  function PercentDisplay() {
    var _temp, _this, _ret;

    _classCallCheck(this, PercentDisplay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      return React.createElement(
        "span",
        null,
        _this.props.percent,
        "% Loaded"
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PercentDisplay;
}(PureComponent);

PercentDisplay.propTypes = {
  percent: PropTypes.number
};

export default PercentDisplay;